import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Card, Typography, Grid, Row, Col, Button } from '@sm/wds-react';

import './product-tile.scss';
import { linkPropType } from '../../../propTypes';
import useBrowser, { BROWSER } from '../../../helpers/useBrowser';
import getClickHandlers from '../../../helpers/getClickHandlers';

export const TEST_ID = 'ProductTile';

const ProductTile = ({ title, image, body, ctaButton, link }) => {
  const isIE = useBrowser() === BROWSER.IE;
  const outerClasses = classnames({
    'sm-product-tile': !isIE,
    'sm-product-tile--ie': isIE,
  });

  return (
    <Card className={outerClasses} padding={false} data-testid={TEST_ID}>
      <Grid noBleeds noGutters fluid className="wds-h-100">
        <Row className="sm-product-tile__image-row">
          <Col
            className={classnames({
              'sm-product-tile__image-wrapper': !isIE,
              'sm-product-tile__image-wrapper--ie': isIE,
            })}
          >
            <img alt={title} src={image} className="sm-product-tile__image" />
          </Col>
        </Row>
        <Row className="wds-h-100">
          <Grid noBleeds noGutters fluid className="sm-product-tile__body">
            <Row className="sm-product-tile__body-row">
              <Col>
                <Typography variant="cardTitle" className="sm-product-tile__title">
                  {title}
                </Typography>
                <p>
                  <Typography variant="bodySm" component="span">
                    {body}
                  </Typography>
                </p>
              </Col>
            </Row>
            <If condition={ctaButton || link}>
              <Row className="sm-product-tile__body-row sm-product-tile__cta">
                <If condition={ctaButton}>
                  <Col xs={5}>
                    <Button
                      color="secondary"
                      variant="ghost"
                      className="sm-product-tile__cta-button"
                      href={ctaButton.href}
                      disabled={ctaButton.disabled}
                      stretched
                      {...getClickHandlers(() => {
                        if (ctaButton.logging) ctaButton.logging();
                      })}
                    >
                      {ctaButton.text}
                    </Button>
                  </Col>
                </If>
                <If condition={link}>
                  <Col
                    className={classnames({
                      'wds-p-l-3': ctaButton,
                      'sm-product-tile__secondary-link': true,
                    })}
                  >
                    <Typography variant="cardTitle" align="left">
                      <a
                        href={link.href}
                        {...getClickHandlers(() => {
                          if (link.logging) link.logging();
                        })}
                      >
                        {link.text}
                      </a>
                    </Typography>
                  </Col>
                </If>
              </Row>
            </If>
          </Grid>
        </Row>
      </Grid>
    </Card>
  );
};

ProductTile.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  ctaButton: linkPropType,
  link: linkPropType,
};

ProductTile.defaultProps = {
  ctaButton: null,
  link: null,
};

export default ProductTile;
